export const POPUP_CHANNELS_TYPE = {
  use: 'use',
  sell: 'sell'
};
